import type { StateCreator } from 'zustand';
import { userTournamentStatus } from '@/api/tournaments';
import type { TopPlayer } from '@/modules/common/hooks/useTournaments';
import type {
  CommonStoreType,
  TournamentsState,
} from '@/store/commonStore/types';

export const useTournamentsSlice: StateCreator<
  CommonStoreType,
  [],
  [],
  TournamentsState
> = (set, get) => ({
  tournaments: [],
  userTournamentsStatuses: [],
  activeTournaments: [],
  fetchUserTournamentStatus: async () => {
    try {
      const { data: userTournamentsStatuses } = await userTournamentStatus();

      set({ userTournamentsStatuses });
    } catch (error) {
      console.log(error);
    }
  },
  updateUserTournamentStatus: (newTournamentStatus: TopPlayer) => {
    set({
      userTournamentsStatuses: get().userTournamentsStatuses.map(
        (userTournament) =>
          userTournament.tournamentId === newTournamentStatus.tournamentId
            ? newTournamentStatus
            : userTournament
      ),
    });
  },
});
